import React from "react";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import ICODevHero from "./ICODevHero";
import ICODevService from "./ICODevService";
import Whitepaper from "./Whitepaper";
import UnlockYourProject from "./UnlockYourProject";
import WhyChooseXeer from "../../DeFi/DeFiStaking/WhyChooseXeer";

function ICODevelopment() {
  return (
    <div>
      <Header />
      <ICODevHero />
      <ICODevService />
      <Whitepaper />
      <UnlockYourProject />
      <WhyChooseXeer />
      <Footer />
    </div>
  );
}

export default ICODevelopment;
